import React from "react";

//Indicador de carga accesible. En vez de dejar la pantalla en blanco (return
//null) mientras se resuelven los datos, muestra un spinner con role="status"
//y aria-live para que los lectores de pantalla anuncien la espera.
const Cargando = ({ mensaje = "Cargando..." }) => (
  <div
    className="d-flex flex-column align-items-center justify-content-center text-center p-5"
    style={{ minHeight: "60vh" }}
    role="status"
    aria-live="polite"
  >
    <div className="spinner-border ppr-color-azul" aria-hidden="true"></div>
    <p className="mt-3 mb-0 ppr-color-azul font-weight-bold">{mensaje}</p>
  </div>
);

export default Cargando;
